export default "__VITE_ASSET__DTKcuOCi__"